import { injectReducers, injectSagas } from 'store'

export const getReducerKeys = (entries) => entries.map((entry) => entry.reducerKey).filter(Boolean)

const entryMatchesRoute = (entry, routeKey) => {
  if (!routeKey) {
    return false
  }

  if (!entry.routeKeys?.length) {
    return true
  }

  return entry.routeKeys.includes(routeKey)
}

export const getEntriesForRoute = (entries, routeKey) => entries.filter((entry) => entryMatchesRoute(entry, routeKey))

export const getRequiredReducerKeys = (entries, routeKey) =>
  getEntriesForRoute(entries, routeKey)
    .map((entry) => entry.reducerKey)
    .filter(Boolean)

const moduleLoadKey = (entry) => {
  const parts = []
  if (entry.reducerKey) {
    parts.push(`reducer:${entry.reducerKey}`)
  }
  if (entry.sagaKey) {
    parts.push(`saga:${entry.sagaKey}`)
  }
  return parts.join('|')
}

const isEntryLoaded = (entry, loadedModuleKeys) => {
  const key = moduleLoadKey(entry)
  return key ? loadedModuleKeys.has(key) : true
}

export const createDomainLoader = (entries, { loadedModuleKeys }) => async (routeKey) => {
  const pending = getEntriesForRoute(entries, routeKey).filter((entry) => !isEntryLoaded(entry, loadedModuleKeys))

  if (!pending.length) {
    return
  }

  const loaded = await Promise.all(
    pending.map((entry) =>
      Promise.all([
        entry.importReducer ? entry.importReducer() : Promise.resolve(null),
        entry.importSaga ? entry.importSaga() : Promise.resolve(null),
      ]),
    ),
  )

  const reducers = {}
  const sagas = {}

  pending.forEach((entry, index) => {
    const [reducerModule, sagaModule] = loaded[index]

    if (entry.reducerKey && reducerModule?.default) {
      reducers[entry.reducerKey] = reducerModule.default
    }

    if (entry.sagaKey && sagaModule?.default) {
      sagas[entry.sagaKey] = sagaModule.default
    }

    const key = moduleLoadKey(entry)
    if (key) {
      loadedModuleKeys.add(key)
    }
  })

  if (Object.keys(reducers).length) {
    injectReducers(reducers)
  }

  if (Object.keys(sagas).length) {
    injectSagas(sagas)
  }
}
